module.exports = __webpack_public_path__ + "static/media/brand-refresh-location-pin.654d2b1a.svg";